import { useTasksKanbanLogsApi, parseLogFilterParams } from '@pages/tasks-kanban'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const id = to.params.id

  if (typeof id !== 'string' || !id) return

  const params = parseLogFilterParams(to.query)

  void useTasksKanbanLogsApi({ id, params })
})